import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Switch,
  ScrollView,
  Alert,
} from "react-native";
import { observer } from "mobx-react";
import { activityStore } from "../stores/ActivityStore";
import { IContent } from "@interfaces/icontent";
import { goBack } from "../services/NavigationService";
import { Theme } from "../enum/Theme";
import PhotoUploader from "./PhotoUploader";
import { RouteProp, useRoute } from "@react-navigation/native";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import RichTextEditor from "./RichTextEditor";
import { Language } from "@constants/language";
import { LanguageSelector } from "../comps/LanguageSelector";

type ActivityFormRouteProp = RouteProp<
  { [EnumRoutesAppWeb.createEditActivity]: { activity?: IContent } },
  EnumRoutesAppWeb.createEditActivity
>;

const ActivityForm = observer(() => {
  const route = useRoute<ActivityFormRouteProp>();
  const activity = route.params?.activity;

  const [title, setTitle] = useState(activity?.title || "");
  const [description, setDescription] = useState(activity?.description || "");
  const [active, setActive] = useState(activity?.active ?? true);
  const [medias, setMedias] = useState(activity?.medias || []);
  const [lang, setLang] = useState<Language>(activity?.lang || "pt");

  const isFormValid = () => !!title.trim() && !!description.trim();

  const handleSave = async () => {
    if (!isFormValid()) {
      Alert.alert("Atenção", "Preencha todos os campos obrigatórios.");
      return;
    }

    const activityToSave: Omit<IContent, "id"> = {
      title,
      description,
      active,
      medias,
      lang,
      type: "atividade",
    };

    await activityStore.saveActivity(activityToSave, activity?.id);
    goBack();
  };

  return (
    <ScrollView style={styles.container}>
      <Text style={styles.title}>{activity ? "Editar Atividade" : "Nova Atividade"}</Text>

     

      <Text style={styles.section}>Título:</Text>
      <TextInput
        placeholder="Digite o título"
        value={title}
        onChangeText={setTitle}
        style={styles.input}
      />

       <LanguageSelector value={lang} onChange={setLang} />

      <Text style={styles.section}>Descrição:</Text>
      <RichTextEditor
        initialContent={description}
        onChange={setDescription}
      />

      <Text style={styles.section}>Foto:</Text>
      <PhotoUploader
        postId={activity?.id || "tempActivity"}
        media={medias}
        setMedia={setMedias}
        mainMediaUrl={medias.length > 0 ? medias[0].url : ""}
        setMainMediaUrl={() => {}}
      />

      <View style={styles.switchContainer}>
        <Text>Ativo:</Text>
        <Switch value={active} onValueChange={setActive} />
      </View>

      <TouchableOpacity
        style={[
          styles.saveButton,
          { backgroundColor: isFormValid() ? Theme.foreground : "#ccc" },
        ]}
        onPress={handleSave}
        disabled={!isFormValid()}
      >
        <Text style={styles.saveButtonText}>Salvar</Text>
      </TouchableOpacity>
    </ScrollView>
  );
});

export default ActivityForm;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  title: { fontSize: 22, fontWeight: "bold", marginBottom: 20 },
  section: { marginTop: 15, fontWeight: "bold" },
  input: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 5,
    padding: 10,
    marginBottom: 10,
  },
  switchContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  saveButton: {
    padding: 15,
    borderRadius: 5,
    marginTop: 20,
  },
  saveButtonText: {
    color: "#fff",
    textAlign: "center",
    fontWeight: "bold",
  },
});
